import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import SubcategoryEditForm from './SubcategoryEditForm';
import SubcategoryEditDialogHeader from './SubcategoryEditDialogHeader';

const SubcategoryEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} Subcategory`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <SubcategoryEditDialogHeader modal={modal} />
      <SubcategoryEditForm modal={modal} isEdit={isEdit} id={id} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(SubcategoryEditDialog);
